export default __webpack_public_path__ + "static/media/handbookOrderSuccess.ab24fb5f.png";